import { formatNumber } from "@/utils/formatting/format-number"

export function formatNullableMetricValue(
  value: number | null | undefined,
  unit?: string | null,
): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return "—"
  }
  const suffix = unit ? (unit === "%" ? unit : ` ${unit}`) : ""
  return `${unit === "s" ? value.toFixed(2) : formatNumber(value)}${suffix}`
}
